import { useComputedColorScheme } from '@mantine/core';
import { useEffect } from 'react';
import type { FunctionComponent } from 'react';

/**
 * Pantry's dark tokens key on `data-color-scheme`, Mantine writes
 * `data-mantine-color-scheme`. Mirror it so both switch together.
 */
export const useSyncPantryColorScheme = (): void => {
  const colorScheme = useComputedColorScheme('light');

  useEffect(() => {
    document.documentElement.dataset.colorScheme = colorScheme;
  }, [colorScheme]);
};

// Mounted above the router so it also runs when a root errorElement replaces Layout
export const PantryColorSchemeSync: FunctionComponent = () => {
  useSyncPantryColorScheme();
  return null;
};
